module.exports = __webpack_public_path__ + "img/Flag_of_Belarus (1).e0ce0555.svg";